export default __webpack_public_path__ + "static/media/a011-startup-4.9bef5a30.svg";